import { Chip, Grid } from "@material-ui/core/";
import MaterialTable from "material-table";
import { useHistory, useRouteMatch } from "react-router-dom";
import colorChange from "../../utils/colorChanges";

const TableOnTask = (props) => {
	const { path } = useRouteMatch();
	const { getDataTable, BaseUrl, tableRef, pageSize, modalAdd, state } = props;
	const history = useHistory();
	const columns = [
		{
			title: "No Ticket",
			field: "idticket",
		},
		{
			title: "Priority",
			field: "priority",
			render: (rowData) => (
				<Chip
					clickable
					label={`#${rowData.priority}`}
					size="medium"
					style={{
						backgroundColor: colorChange(rowData.priority).backgroundColor,
						color: colorChange(rowData.priority).color,
						fontWeight: "bold",
					}}
					variant="outlined"
				/>
			),
		},
		{ title: "Subject", field: "title_issue" },
		{ title: "Author", field: "nama_author" },
		{ title: "Service", field: "layanan" },
		{ title: "Category", field: "kategori" },
		{ title: "Location", field: "location" },
		{ title: "User Assignee", field: "user_assignee" },
		{ title: "Group Assignee", field: "group_assignee" },
		{ title: "StartDate", field: "start_time" },
		{ title: "DueDate", field: "deadline_time" },
		{ title: "Work Time", field: "work_time" },
		{
			title: "Status Deadline",
			field: "status_deadline",
			render: (rowData) => (
				<Chip
					clickable
					label={rowData.status_deadline}
					size="medium"
					style={{
						backgroundColor: colorChange(rowData.status_deadline)
							.backgroundColor,
						color: colorChange(rowData.status_deadline).color,
						fontWeight: "bold",
					}}
					variant="outlined"
				/>
			),
		},
		{
			title: "Ticket Status",
			field: "status",
			render: (rowData) => (
				<Chip
					clickable
					label={rowData.status}
					size="medium"
					style={{
						backgroundColor: colorChange(rowData.status).backgroundColor,
						color: colorChange(rowData.status).color,
						fontWeight: "bold",
					}}
					variant="outlined"
				/>
			),
		},
	];

	return (
		<Grid
			item
			direction="column-reverse"
			justifyContent="space-between"
			alignItems="stretch"
		>
			<Grid
				item
				style={{
					boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
				}}
			>
				<MaterialTable
					title="Task"
					tableRef={tableRef}
					columns={columns}
					data={getDataTable({
						url: `${BaseUrl}`,
						state: state,
						type: "tasks",
					})}
					onRowClick={(event, rowData) =>
						history.push(`${path}/${rowData.idticket}`)
					}
					actions={[
						{
							icon: "add_box",
							tooltip: "Add",
							isFreeAction: true,
							onClick: () => modalAdd(),
						},
					]}
					options={{
						actionsColumnIndex: -1,
						paginationType: "stepped",
						pageSize: pageSize,
						pageSizeOptions: [10, 50, 100, 200],
						headerStyle: {
							backgroundColor: "#67A3D5",
							color: "#FFF",
						},
						rowStyle: (rowData) => {
							if (rowData.tableData.id % 2) {
								return {
									backgroundColor: "#EEEEEE",
								};
							}
							return {
								backgroundColor: "#fff",
							};
						},
					}}
				/>
			</Grid>
		</Grid>
	);
};

export default TableOnTask;
